<template>
  <section class="asc-plot-overlays-list--container">
    <div ref="list" class="asc-plot-overlays-list">
      <asc-plot-overlay
        v-for="(item, index) in overlayItems"
        :key="index"
        v-model="item.status"
        :title="item.name"
        :status="item.status"
        :on-update="handleOverlayUpdate"
        class="asc-plot-overlays-list--item"
      />
    </div>
  </section>
</template>

<script>
import AscPlotOverlay from '@/components/molecules/AscPlotOverlay'
import { OVERLAYS } from '@/utilities/appConsts'

export default {
  name: 'AscPlotOverlayList',

  components: {
    AscPlotOverlay,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    onUpdate: {
      type: Function,
      required: true,
    },
  },

  data: function () {
    return { overlayItems: this.getOverlayoptionsDetails() }
  },

  methods: {
    getOverlayoptionsDetails() {
      const self = this
      return this.items.length
        ? OVERLAYS.filter(function (option) {
            return self.items.indexOf(option.id) !== -1
          })
        : []
    },
    handleOverlayUpdate() {
      this.onUpdate(
        this.overlayItems
          .filter(function (item) {
            return item.status
          })
          .map(item => item.id),
      )
    },
  },
}
</script>

<style lang="scss">
.asc-plot-overlays-list--container {
  .asc-plot-overlays-list {
    display: flex;
    flex-flow: row nowrap;
    flex: 0 1 auto;
    overflow-x: auto;

    &--item {
      border-right: 1px solid $gray-300;

      &:last-child {
        border: none;
      }
    }
  }
}
</style>
